// extracted by mini-css-extract-plugin
module.exports = {"mermaid":"mermaid_mermaid__TQEdh"};